export default __webpack_public_path__ + "static/media/th.fad1a8c3.svg";